import styled from 'styled-components';

import { ColorName } from 'types';

import { getHoverColor, pickColor } from 'themes/helpers/pickColor';

import { Button } from 'components/Button';
import { Headline } from 'components/Headline';

const Container = styled.div`
  width: 60rem;
`;

const SuccessIcon = styled.span`
  width: 30px;
  height: 40px;
  display: inline-block;
`;

const Title = styled(Headline)`
  padding: 1.5rem;
  color: ${pickColor('greenStatus')};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
`;

const Info = styled(Headline)`
  padding: 1.5rem 0 4rem 1.5rem;

  border-top: 0.1rem solid ${pickColor('borderSemiLight')};
  border-bottom: 0.1rem solid ${pickColor('borderSemiLight')};
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 2rem;

  padding: 1.5rem;
`;

const ButtonGo = styled(Button)<{ barColor: ColorName }>`
  background-color: ${({ barColor }) => barColor && pickColor(barColor)};
  &:hover {
    background-color: ${({ barColor }) => barColor && pickColor(getHoverColor(barColor))};
  }
`;

export { Actions, ButtonGo, Container, Info, SuccessIcon, Title };
